var _circle, _path, _path2, _path3, _path4, _path5, _circle2, _circle3, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 98,
    viewBox: "0 0 92 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 46,
    cy: 46,
    r: 46,
    fill: "#F9F9FD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 31C22 30.4477 22.4477 30 23 30H67C67.5523 30 68 30.4477 68 31V39C68 39.5523 67.5523 40 67 40H23C22.4477 40 22 39.5523 22 39V31Z",
    fill: "#B5B7E6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 44C22 43.4477 22.4477 43 23 43H31C31.5523 43 32 43.4477 32 44V52C32 52.5523 31.5523 53 31 53H23C22.4477 53 22 52.5523 22 52V44Z",
    fill: "#B5B7E6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35 44C35 43.4477 35.4477 43 36 43H67C67.5523 43 68 43.4477 68 44V52C68 52.5523 67.5523 53 67 53H36C35.4477 53 35 52.5523 35 52V44Z",
    fill: "#B5B7E6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22 57C22 56.4477 22.4477 56 23 56H31C31.5523 56 32 56.4477 32 57V65C32 65.5523 31.5523 66 31 66H23C22.4477 66 22 65.5523 22 65V57Z",
    fill: "#B5B7E6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35 57C35 56.4477 35.4477 56 36 56H67C67.5523 56 68 56.4477 68 57V65C68 65.5523 67.5523 66 67 66H36C35.4477 66 35 65.5523 35 65V57Z",
    fill: "#B5B7E6"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 35,
    r: 2,
    fill: "#F9F9FD"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 69,
    cy: 85,
    r: 13,
    fill: "#DE4C45"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0508 78.986V84.134C70.0508 84.68 70.0238 85.217 69.9698 85.745C69.9158 86.267 69.8468 86.822 69.7628 87.41H68.2508C68.1668 86.822 68.0978 86.267 68.0438 85.745C67.9898 85.217 67.9628 84.68 67.9628 84.134V78.986H70.0508ZM67.6118 90.776C67.6118 90.59 67.6448 90.413 67.7108 90.245C67.7828 90.077 67.8788 89.933 67.9988 89.813C68.1248 89.693 68.2718 89.597 68.4398 89.525C68.6078 89.453 68.7878 89.417 68.9798 89.417C69.1658 89.417 69.3428 89.453 69.5108 89.525C69.6788 89.597 69.8228 89.693 69.9428 89.813C70.0688 89.933 70.1678 90.077 70.2398 90.245C70.3118 90.413 70.3478 90.59 70.3478 90.776C70.3478 90.968 70.3118 91.148 70.2398 91.316C70.1678 91.478 70.0688 91.619 69.9428 91.739C69.8228 91.859 69.6788 91.952 69.5108 92.018C69.3428 92.09 69.1658 92.126 68.9798 92.126C68.7878 92.126 68.6078 92.09 68.4398 92.018C68.2718 91.952 68.1248 91.859 67.9988 91.739C67.8788 91.619 67.7828 91.478 67.7108 91.316C67.6448 91.148 67.6118 90.968 67.6118 90.776Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoData);
export default __webpack_public_path__ + "static/media/NoData.f01a733fc56c1e225e29cd0f13245e19.svg";
export { ForwardRef as ReactComponent };